<template>
  <div
    class="tw-relative tw-w-full tw-h-full tw-pb-4 md:tw-h-screen tw-bg-no-repeat tw-bg-cover tw-bg-boss-section tw-overflow-hidden"
  >
    <!-- <div class="tw-absolute tw-top-0 tw-w-full tw-h-32 tw-bg-white"></div> -->
    <!-- Tag Section -->
    <div
      class="tw-relative tw-w-full tw-h-1/10 tw-mt-8 md:tw-absolute md:tw-left-0 md:tw-top-0 md:tw-w-2/12 md:tw-h-full md:tw-mt-0"
    >
      <div class="xl:tw-h-1/6 lg:tw-h-2.5/10 tw-flex tw-items-end">
        <section-tag tag-name="boss monster" :tag-number="slidePage" />
      </div>
    </div>

    <div class="tw-w-full tw-h-8 xl:tw-h-1/10 lg:tw-h-1.5/10"></div>
    <div class="tw-flex tw-flex-row tw-h-full">
      <div class="carousel-wrapper tw-flex flex-row tw-w-full tw-h-full">
        <div class="tw-w-full md:tw-w-1/12 tw-h-full tw-z-0"></div>
        <div
          class="tw-w-full md:tw-w-11/12 tw-h-full tw-overflow-visible"
          v-if="!mobile"
        >
          <VueSlickCarousel
            v-bind="settings"
            @beforeChange="beforeChangeCarousel"
          >
            <div
              v-for="(boss, index) in bossData"
              :key="index"
              class="tw-h-full tw-flex tw-items-center tw-justify-center"
            >
              <div
                class="tw-relative tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-center tw-w-full tw-h-full"
              >
                <!-- desktop -->
                <div
                  v-animate="{ value: 'fadeInRight', delay: 500 }"
                  class="tw-relative xl:tw-block tw-flex tw-w-full md:tw-w-1/2 tw-h-full tw-overflow-visible"
                >
                  <img
                    :class="boss.className"
                    class="tw-w-max"
                    :src="`${imgPath}${boss.imgUrl}`"
                  />
                </div>

                <div class="tw-w-1/2 tw-h-full tw-flex tw-flex-col">
                  <span
                    v-animate="{ value: 'fadeInRight', delay: 100 }"
                    class="tw-w-1/2 tw-font-caslon xl:tw-text-8.8 lg:tw-text-4.4 tw-text-pure-yellow tw-leading-none tw-uppercase"
                    v-html="boss.name"
                  ></span>
                  <span
                    v-animate="{ value: 'fadeInRight', delay: 300 }"
                    class="tw-text-white tw-text-lg tw-font-bold xl:tw-mt-12 xl:tw-text-2.2 lg:tw-mt-5 lg:tw-text-1.9"
                    v-html="boss.subtitle"
                  ></span>
                  <p
                    v-animate="{ value: 'fadeInRight', delay: 900 }"
                    class="tw-text-white tw-font-medium xl:tw-max-w-3xl lg:tw-max-w-2xl xl:tw-mt-12 xl:tw-h-auto xl:tw-text-1.6 xl:tw-overflow-y-hidden lg:tw-mt-7 lg:tw-text-1.5 lg:tw-h-500 lg:tw-overflow-y-scroll"
                    v-html="boss.desc"
                  ></p>
                </div>
              </div>
            </div>
            <template #customPaging="page">
              <div
                v-animate="{ value: 'fadeInRight', delay: 1200 }"
                class="dots-wrapper tw-relative tw-custom-dot tw-w-28 tw-h-28"
              >
                <div
                  class="slick-dots-active tw-w-28 tw-h-28 tw-rounded-full tw-absolute inset-center tw-z-10"
                ></div>
                <img
                  class="absolute tw-w-28 tw-h-28 inset-center"
                  :src="`${imgPath}${bossPaging[page].imgUrl}`"
                />
              </div>
            </template>
          </VueSlickCarousel>
        </div>
        <div
          v-if="mobile"
          class="tw-w-full md:tw-w-11/12 md:tw-h-full tw-overflow-visible"
        >
          <VueSlickCarousel
            v-bind="settings"
            @beforeChange="beforeChangeCarousel"
          >
            <div
              v-for="(boss, index) in bossData"
              :key="index"
              class="tw-h-full tw-flex tw-items-center tw-justify-center"
            >
              <div
                class="tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full"
              >
                <span
                  class="tw-absolute tw-left-7 tw-top-0 tw-font-caslon tw-text-pure-yellow tw-leading-none tw-uppercase tw-text-5.4 tw-z-10"
                  v-html="boss.name"
                ></span>

                <div class="tw-relative tw-w-full tw-mt-12">
                  <img
                    class="tw-transform tw--scale-x-1"
                    :src="`${imgPath}${boss.imgUrl}`"
                  />
                </div>
                <div
                  class="tw-mx-4 tw-px-12 tw-pb-9 tw-relative tw--mt-32 tw-h-400 tw-bg-black tw-bg-opacity-70 tw-pt-36"
                >
                  <span
                    class="tw-text-white tw-text-1.8 tw-font-bold"
                    v-html="boss.subtitle"
                  ></span>
                  <p
                    class="tw-text-white tw-text-1.2 tw-overflow-y-auto tw-h-96 tw-mt-2 tw-font-medium"
                    v-html="boss.desc"
                  ></p>
                </div>
              </div>
            </div>
            <template #customPaging="page">
              <div
                class="dots-wrapper tw-relative tw-custom-dot tw-w-20 tw-h-20"
              >
                <div
                  class="slick-dots-active tw-w-20 tw-h-20 tw-rounded-full tw-absolute inset-center tw-z-10"
                ></div>
                <img
                  class="absolute tw-w-20 tw-h-20 inset-center"
                  :src="`${imgPath}${bossPaging[page].imgUrl}`"
                />
              </div>
            </template>
          </VueSlickCarousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTag from "../components/SectionTag";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "boss-section",
  components: { VueSlickCarousel, SectionTag },
  props: {
    mobile: Boolean,
  },
  data: function() {
    return {
      slidePage: "01",
      settings: {
        dots: true,
        arrows: false,
        fade: true,
        autoplay: false,
        adpativeHeight: true,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              autoplay: false,
              fade: false,
            },
          },
        ],
      },
      imgPath: process.env.VUE_APP_IMG_URL,
      bossData: [
        {
          className: "boss1",
          imgUrl: "/monster-boss1.png",
          name: "RETE OF OBLIVION",
          subtitle: 'User of the Cursed Artifact, the "Flame of Truth"',
          desc:
            "In the beginning, there was a girl. The girl loved living in the world that was created. However, those who have similar powers as her cursed her. It was because the girl with heterogeneous power with them did not have enemies in either force, and the 'truth' the girl showed was fear itself. Those who fought under the names of the ancient Gods found an easy way to deal with this girl... Throwing the girl into the gap between time and space.<br/><br/>The girl raged and dropped some of her power to the world. It was a cursed material that makes people who are not chosen forget everything. The Howl Kingdom treasured this artifact and kept it in the Zisk Plains. For hundreds of years, the Flame of Truth has disappeared from everyone's memory, as if someone erased their memories. In the meantime, the Flame of Truth seemed to be gradually getting smaller and extinguished.<br/><br/>Then one day, space and time that had locked her up opened, allowing the girl to return to the world she loved. However, as the suspicious force approached, she hurriedly escaped into her flame.<br/><br/>However, the flame, which had already been contaminated by some force for a long time, got contaminated even more. In the end, the girl ended up wandering around the lake.",
        },
        {
          className: "boss2",
          imgUrl: "/monster-boss2.png",
          name: "SHADOW SNAKE",
          subtitle: "Hidden Darkness inside the Void Star",
          desc:
            "There was a darkness hidden inside the Void Star, which was shaped like a huge snake. In a way, it could have been darkness full of evil, but it was not. It was just a shadow that faithfully followed the will of the main body that is hiding in the Void Star.<br/><br/>Snake Shadow.<br/><br/>The shadow, which mimicked the behavior of any snake, did nothing as if it cannot move. The shadow, which was asleep in a warped gap between time and space, felt someone's presence and used power as the body intended.<br/><br/>Hopefully, no one steps in here.<br/>Hopefully, no one cares about this place.<br/><br/>The shadow knew instinctively. To be with its main body, it has to kill the adventurer that is interfering between them... And that it will meet its main body any time soon.<br/><br/>So the shadow was ready to swallow the adventurer.",
        },
      ],
      bossPaging: [
        {
          imgUrl: "/bmonster-icon01.png",
        },
        {
          imgUrl: "/bmonster-icon02.png",
        },
      ],
    };
  },
  methods: {
    beforeChangeCarousel: function(oldIndex, newIndex) {
      //console.log(newIndex);
      let number = newIndex + 1;
      this.slidePage = `0${number}`;
    },
  },
};
</script>

<style lang="postcss" scoped>
/* .boss1 {
  @apply tw-absolute xl:tw-w-110%  xl:tw--left-1.5/10 tw--bottom-1/10;
}
.boss2 {
  @apply tw-absolute xl:tw-w-8/12  xl:tw--left-1.5/10 tw--bottom-1/10;
} */
.carousel-wrapper >>> .slick-track {
  @apply tw-flex;
}
.carousel-wrapper >>> .slick-slide {
  @apply md:tw-h-full;
}
.carousel-wrapper >>> .slick-list {
  @apply tw-overflow-visible;
}
.carousel-wrapper >>> .slick-dots {
  @apply tw-w-72 tw-right-0 tw-left-0 tw-bottom-330 tw-flex tw-items-center tw-m-auto tw-justify-center 2xl:tw-right-1/10 xl:tw-w-60 xl:tw-left-auto xl:tw-top-1/4 xl:tw--right-0 xl:tw-flex-col md:tw-w-72 md:tw-left-1.5/10 md:tw-right-auto md:tw-bottom-0.5/10 md:tw-flex-row md:tw-m-auto md:tw-justify-start !important;
}
.carousel-wrapper >>> .slick-dots li {
  @apply tw-w-20 tw-h-20 md:tw-w-28 md:tw-h-28 md:tw-mt-3;
}
.carousel-wrapper >>> .slick-dots li .dots-wrapper .slick-dots-active {
  @apply tw-bg-black tw-bg-opacity-75;
}
.carousel-wrapper
  >>> .slick-dots
  .slick-active
  .dots-wrapper
  .slick-dots-active {
  @apply tw-bg-opacity-0 tw-bg-transparent tw-shadow-dots-active;
}
</style>
